//Styles
import Style from "./SystemSttings.module.scss";

import BaseAppContainer from "../base--app-container/BaseAppContainer"
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu";
import { useState } from "react";
import Appearance from "./appearance/Appearance";
import Display from "./display/Display";
import Wallpapers from "./wallpaper/Wallpapers";
import DefaultSettingsScreen from "./default-setings-screen/DefaultSettingsScreen";
import { APP_KEY_IDS } from "../../constants/constants";
import { getCurrentOption } from "../../global/functions/functrions";
import DockSettings from "./dock/DockSettings";


interface SystemSettingsProps{
  wallpapers:any;
  screensavers:any;
}

const SystemSettings = ({wallpapers,screensavers}:SystemSettingsProps) => {


  const leftMenuItem = [
    {
      
      options: [
        {
        id: "0",
          label: "Wifi"
        },
        {
        id: "1",
          label: "Bluetooth"
        },
        {
        id: "2",
          label: "Network"
        },
        {
        id: "3",
          label: "VPN"
        },
      ]
    },
    {
      
      options: [
        {
        id: "4",
          label: "Notifications"
        },
        {
        id: "5",
          label: "Sound"
        },
        {
        id: "6",
          label: "Focus"
        },
        {
        id: "7",
          label: "ScreenTime"
        },
      ]
    },
    {
      
      options: [
        {
        id: "8",
          label: "General"
        },
        {
        id: "9",
          label: "Appearance"
        },
        {
        id: "10",
          label: "Accessibility"
        },
        {
        id: "11",
          label: "Control Center"
        },
        {
        id: "12",
          label: "Siri & Spotlight"
        },
        {
        id: "13",
          label: "Privacy & Security"
        },
      ]
    },
    {
      
      options: [
        {
        id: "14",
          label: "Dock & Menubar"
        },
        {
        id: "15",
          label: "Displays"
        },
        {
        id: "16",
          label: "Wallpaper"
        },
        {
        id: "17",
          label: "Screen Saver"
        },
        {
        id: "18",
          label: "Weather"
        },
        {
        id: "19",
          label: "Control Center"
        },
        {
        id: "20",
          label: "Siri & Spotlight"
        },
        {
        id: "21",
          label: "Privacy & Security"
        },
      ]
    }

  ]

  const lightThemeOptions=new Set(["16","17"])

  const [activeOption, setActiveOption] = useState("0");
  const [activeOptionTitle, setActiveOptionTitle] = useState("System Settings");



  const getMainScreen=()=>{
    switch(getCurrentOption(activeOption)){
      case "9":return <Appearance/>
      case "15":return <Display/>
      case "14":return <DockSettings />
      case "16":return <Wallpapers type={"background"} screensavers={screensavers} wallpapers={wallpapers}/>
      case "17":return <Wallpapers type={"screensaver"} screensavers={screensavers} wallpapers={wallpapers}/>
      default: return <DefaultSettingsScreen/>
    }
  }

  return (
    <BaseAppContainer appId={APP_KEY_IDS.SETTINGS} width={900}
    loadFromX={30} height={600} title={activeOptionTitle ||  "System Settings"} showHeader={false} showSearchBar={true} 
    SideBar={
      <div className={Style.left_container}>
        <LeftPanelMenu menuContent={leftMenuItem} activeValue={activeOption} handleOptionClick={setActiveOption} setTitle={setActiveOptionTitle} />
      </div>} 
    MainScreen={getMainScreen()} 
    lighTheme={lightThemeOptions.has(activeOption)}/>
  )
}

export default SystemSettings
